import { render, staticRenderFns } from "./DIASRealEstateLuovutusilmoitus.vue?vue&type=template&id=106ae770&"
import script from "./DIASRealEstateLuovutusilmoitus.vue?vue&type=script&lang=js&"
export * from "./DIASRealEstateLuovutusilmoitus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports